module.exports = __webpack_public_path__ + "static/media/info-icon.a28c5d24.svg";